import {
  anInsightResolution,
  anInsightResolutionPage,
  InsightResolutionPage,
  mockInsightResolutionQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const CUSTOM_INSIGHT_RESOLUTION = {
  description: 'The resolved incident was fixed.',
  name: 'Fixed',
};

export const PARENT_NAME = 'Resolved';

export const getInsightResolutionMockData = (
  withSubResolutions = false
): Partial<InsightResolutionPage> => ({
  total: 4,
  hasNextPage: false,
  objects: [
    anInsightResolution({
      id: 1,
      name: 'Duplicate',
      subResolutions: [],
    }),
    anInsightResolution({
      id: 2,
      name: 'False Positive',
      subResolutions: [],
    }),
    anInsightResolution({
      id: 3,
      name: 'No Action',
      subResolutions: [],
    }),
    anInsightResolution({
      id: 4,
      name: 'Resolved',
      subResolutions: withSubResolutions
        ? [
            anInsightResolution({
              id: 5,
              description: CUSTOM_INSIGHT_RESOLUTION.description,
              name: CUSTOM_INSIGHT_RESOLUTION.name,
            }),
          ]
        : [],
    }),
  ],
});

export const insightResolutionQuery_updated =
  mockInsightResolutionQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insightResolutions: anInsightResolutionPage(
            getInsightResolutionMockData(true)
          ),
        },
      });
    }
  );

export const handlers = [
  mockInsightResolutionQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insightResolutions: anInsightResolutionPage(
            getInsightResolutionMockData()
          ),
        },
      });
    }
  ),
];
